import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { IFileUploadManagerMini } from '../../../core/service/file.service';
import { Attachment } from '../../../common/model/attachment';
@Injectable()
export class ComponentService implements IFileUploadManagerMini {
  constructor(private _client: HttpClient, private _messageService: MessageService, @Inject(APP_CONFIG) config: IAppConfig) {
    this._endpoint = `${config.apiEndpointV2}/component-attachment`;
  }
  private readonly _endpoint: string;

  uploadFile(file: Attachment, componentId: string): Observable<string> {
    const formData = new FormData();
    const blob = new Blob([file.data as BlobPart], { type: file.mimeType });
    formData.append('file', blob, file.title);
    formData.append('componentId', componentId);
    return this._client.post<any>(`${this._endpoint}`, formData).pipe(
      map(response => response.id as string),
      catchError(error => {
        this._messageService.showError(error);
        throw error;
      })
    );
  }

  downloadFile(id: string): Observable<File> {
    return this._client.get(`${this._endpoint}/download/${id}`, { responseType: 'blob' }).pipe(
      map(blob => new File([blob], `file_${id}`)),
      catchError(error => {
        this._messageService.showError(error);
        throw error;
      })
    );
  }

  deleteFile(id: string): Observable<void> {
    return this._client.delete<void>(`${this._endpoint}/${id}`).pipe(
      catchError(error => {
        this._messageService.showError(error);
        throw error;
      })
    );
  }
}
